<template>
  <MultipleSelector
    localSearch
    data-testid="multipleSiteSelector-multipleSelector-sites"
    :buttonText="$t('multiple_selector.add_site')"
    :disabled="disabled"
    :label="$t('common.site_other')"
    :options="siteOptions"
    :selectionLimit="maxSites"
    :type="$t('common.site_other')"
    :value="value"
    :zIndex="zIndex"
    @change="$emit('change', $event)"
  />
</template>

<script>
import { mapGetters } from 'vuex'

import MultipleSelector from '@/components/MultipleSelector/MultipleSelector.vue'

export default {
  name: 'MultipleSiteSelector',

  components: {
    MultipleSelector,
  },

  props: {
    disabled: Boolean,
    maxSites: { type: Number, default: 15 },
    options: { type: Array, default: null },
    value: { required: true, type: Array },
    zIndex: Number,
  },

  computed: {
    ...mapGetters(['organizationSites']),

    siteOptions() {
      const sites = this.options ?? this.organizationSites

      return sites.map(site => {
        return {
          ...site,
          icon: 'mdi-warehouse',
          title: site.name,
          subtitle: this.$t(`countries.${site.countryCodes[0]}`),
        }
      })
    },
  },
}
</script>
